import IVendorConfig from "src/environments/Ivendor-config";

export function synnexAusMapper(config: IVendorConfig){
  config.brandsOptionsToDisplay = [
    "ASUS",
    "HP",
  ];
}
